import { styled } from '@linaria/react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

import segob from '../../assets/footer/segob.webp'
import ssl from '../../assets/footer/ssl.webp'
import gordon_moody_logo from '../../assets/footer/gordon_moody_logo.webp'
import plus_18_logo from '../../assets/footer/plus_18_logo.webp'

const Container = styled.div`
  padding: 0 20px;
  padding-bottom: 50px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: var(--highlight);
  font-family: 'Inter', sans-serif;
  font-weight: 300;
  @media (min-width: 1200px) {
    padding: 0 30px;
  }
`

const Wrapper = styled.div`
  padding: 0 0 25px;
  border-bottom: 1px solid var(--highlight);
  margin-bottom: 30px;
  @media (min-width: 1200px) {
    padding-bottom: 10px;
    border-bottom: 0;
  }
`

const Row = styled.div`
  flex-wrap: wrap;
  gap: 12px;
  & img {
    height: 33px;
  }
  & .parent-consent {
    display: inline-flex;
  }
  & .parent-consent > img:first-child {
    margin-right: 4px;
  }
  @media (min-width: 1200px) {
    gap: 16px;
    padding: 0;
    & img {
      height: 45px;
    }
  }
`

const Copyrights = () => {
  return (
    <Container>
      <Wrapper>
        <div>
          <Row className="flx-ctr">
            <a href="https://gamblingtherapy.org" target="blank" aria-label="Read more about Gambling Therapy">
              <LazyLoadImage
                src={gordon_moody_logo}
                alt="therapy for gaming addiction gordon moody"
                style={{ aspectRatio: '86 / 33' }}
              />
            </a>
            <a
              href="http://www.juegosysorteos.gob.mx/es/Juegos_y_Sorteos/Atencion_al_Ludopata"
              target="blank"
              aria-label="Read more about Segob">
              <LazyLoadImage
                src={segob}
                alt="YAK"
                style={{ aspectRatio: '107 / 33' }}
              />
            </a>
            <span className="parent-consent">
              <LazyLoadImage
                src={plus_18_logo}
                alt={'18 plus'}
                style={{ aspectRatio: '33 / 33' }}
              />
            </span>
            <LazyLoadImage
              src={ssl}
              alt="SSL"
              style={{ aspectRatio: '13 / 4' }}
            />
          </Row>
        </div>
      </Wrapper>
      <p style={{ marginBottom: '15px' }}>
        WWW.FUN88MX.MX OPERADA EN MEXICO POR PRODUCCIONES MÓVILES S.A. DE C.V.,
        TITULAR DEL PERMISO DGAJS/SCEVF/P-06/2005-TER EN UNIÓN DE UNOCAPALI LA
        PAZ OPERADORA S.A. DE C.V. DE CONFORMIDAD CON LOS OFICIOS DGJS/1580/2021
        Y DGJS/DCRCA/1424/2022. JUEGOS PROHIBIDOS PARA MENORES DE EDAD, JUEGUE
        RESPONSABLEMENTE, NO OLVIDE QUE EL PRINCIPAL PROPÓSITO ES LA RECREACIÓN,
        DIVERSIÓN Y ESPARCIMIENTO.
      </p>
    </Container>
  )
}

export default Copyrights
